<template>
  <div v-loading="fullscreenLoading">
    <div style="margin-left:10.5%;overflow:hidden">
      <div style="padding-top:20px"></div>
      <div class="Rectangle-5" v-bind:style="{ height:  + (windowHeight-150) + 'px' }">
        <div style="padding:3%;padding-top:20px">
          <div style>
            <div style="display:inline-block;width:70%;">
              <el-select
                style="display:inline-block;width:150px;vertical-align:middle;margin-right:10px"
                placeholder="请选择店铺"
                v-model="searchShop"
                @keyup.enter.native="onSearchTableData"
              >
                <el-option
                  v-for="item in shopList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>

              <el-cascader
                placeholder="商品分类"
                style="display:inline-block;width:200px;vertical-align:middle;margin-right:10px"
                v-model="searchCate"
                :options="megaCategoriesList"
                :props="cateTwoProps"
                clearable
                @keyup.enter.native="onSearchTableData"
              ></el-cascader>

              <el-select
                style="display:inline-block;width:150px;vertical-align:top;margin-left:0px"
                placeholder="请选择商品状态"
                v-model="searchStatus"
                @keyup.enter.native="onSearchTableData"
              >
                <el-option
                  v-for="item in statusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-select
                style="display:inline-block;width:300px;vertical-align:top;margin-left:10px"
                placeholder="请选择排序"
                multiple
                v-model="searchOrder"
                @keyup.enter.native="onSearchTableData"
              >
                <el-option v-for="item in orderList" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </div>

            <div style="display:inline-block;text-align:right;width:30%">
              <div style="display:inline-block;text-align:right;max-width:40%;margin-right:10px">
                <el-button
                  @click="onDialogBoolAddNewOpen()"
                  style="color:#1bb24b;border-color:#1bb24b"
                >添加新产品</el-button>
              </div>

              <div style="display:inline-block;text-align:right;max-width:40%;margin-right:10px">
                <el-button
                  @click="onDialogBoolMultipleStatusOpen()"
                  style="color:#1bb24b;border-color:#1bb24b"
                >批量修改状态</el-button>
              </div>
            </div>

            <div style="margin-top:10px;">
              <el-select
                style="display:inline-block;width:150px;vertical-align:middle;margin-right:10px"
                placeholder="单位"
                v-model="searchUnit"
                @keyup.enter.native="onSearchTableData"
              >
                <el-option v-for="item in unitListTwo" :key="item" :label="item" :value="item"></el-option>
              </el-select>

              <el-input
                style="display:inline-block;width:200px"
                v-model="searchKeyword"
                placeholder="名称"
                @keyup.enter.native="onSearchTableData"
              ></el-input>

              <el-input
                style="display:inline-block;width:150px;margin-left:10px"
                v-model="searchStorage"
                placeholder="库存"
                @keyup.enter.native="onSearchTableData"
              ></el-input>

              <el-input
                style="display:inline-block;width:15%;margin-left:10px"
                v-model="searchPrice"
                placeholder="价格"
                @keyup.enter.native="onSearchTableData"
              ></el-input>
              <el-select
                style="display:inline-block;width:100px;vertical-align:top;margin-left:10px"
                placeholder="请选择秒杀"
                v-model="searchLimited"
                @keyup.enter.native="onSearchTableData"
              >
                <el-option
                  v-for="item in ifLimitedSearchList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>

              <el-button
                @click="onSearchTableData"
                style="display:inline-block;margin-left:20px;background-color:#1bb24b"
                type="success"
              >搜索</el-button>
            </div>
          </div>

          <div style="margin-top:3%;">
            <el-table
              :data="tableDataList"
              :height="windowHeight-400"
              style="width: 100%"
              stripe
              @selection-change="onProductSelection"
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="productId" label="ID" sortable width="100"></el-table-column>
              <el-table-column prop="shopName" label="所属商家"></el-table-column>
              <el-table-column label="商品图片">
                <template slot-scope="scope">
                  <img style="width:80px;height:80px;" :src="scope.row.imgUrls[0]" />
                </template>
              </el-table-column>
              <el-table-column prop="title" label="商品标题" width="200"></el-table-column>
              <!-- <el-table-column prop="categoriesName" label="商品分类"></el-table-column>
              <el-table-column prop="subCategoriesName" label="子分类"></el-table-column>-->
              <el-table-column prop="unit" label="商品单位"></el-table-column>
              <el-table-column prop="price" label="商品价格" sortable></el-table-column>
              <el-table-column prop="storageNum" label="库存" sortable></el-table-column>
              <el-table-column prop="soldNum" label="销量" sortable></el-table-column>
              <el-table-column prop="status" label="状态"></el-table-column>
              <el-table-column fixed="right" label="操作" width="250">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="onDialogWithData(scope,'edit')">编辑</el-button>
                  <el-button
                    type="text"
                    size="small"
                    v-if="scope.row.status == '下架'"
                    @click="onDialogWithData(scope,'onShelf')"
                  >上架</el-button>
                  <el-button
                    type="text"
                    size="small"
                    v-else
                    @click="onDialogWithData(scope,'offShelf')"
                  >下架</el-button>
                  <el-button type="text" size="small" @click="onDialogWithData(scope,'delete')">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="margin-top:20px;">
            <el-pagination
              background
              :page-size="20"
              :current-page.sync="currentPage"
              layout="prev, pager, next"
              :total="tableDataTotal"
              @current-change="onFetchTableData"
            ></el-pagination>
          </div>
        </div>
      </div>

      <el-dialog
        title="产品操作"
        :close-on-click-modal="false"
        :visible.sync="boolAddNew"
        width="70%"
        style="text-align:left"
        :before-close="onDialogBoolAddNewClose"
      >
        <div>
          <div style="display:inline-block;text-align:left;width:10%;">商品标题</div>
          <el-input style="display:inline-block;width:70%;" v-model="form.title"></el-input>
        </div>

        <div style="margin-top:20px;">
          <div style="display:inline-block;text-align:left;width:10%;vertical-align:top">商品图片</div>
          <div style="display:inline-block;width:70%;">
            <el-upload
              accept=".jpg, .jpeg, .png"
              action="https://freshgo.top/api/public/api/v1/uploadFileQiniu"
              list-type="picture-card"
              :on-success="onProductImgUpload"
              :on-remove="onProductImgRemove"
              :file-list="form.imgUrls"
              multiple
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
        </div>

        <div style="margin-top:20px;">
          <div style="display:inline-block;text-align:left;width:10%;">俏皮描述</div>
          <el-input
            style="display:inline-block;width:70%;"
            v-model="form.detail"
            placeholder="请输入俏皮描述"
          ></el-input>
        </div>

        <div style="margin-top:20px;">
          <div
            style="display:inline-block;text-align:left;width:10%;vertical-align:top;margin-top:20px;"
          >商品详情</div>
          <div style="display:inline-block;width:70%;">
            <el-table border :data="form.description" :height="300" style="width: 100%" stripe>
              <el-table-column prop="type" label="类型"></el-table-column>
              <el-table-column label="内容">
                <template slot-scope="scope">
                  <div v-if="scope.row.type == '文字'">{{scope.row.context}}</div>
                  <div v-else>
                    <img style="width:80px;height:80px;" :src="scope.row.context" />
                  </div>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="250">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="small"
                    @click="onDialogDescriptionWithData(scope,'edit')"
                  >编辑</el-button>

                  <el-button
                    type="text"
                    size="small"
                    @click="onDialogDescriptionWithData(scope,'delete')"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-button
              @click="onDialogAddDescriptionOpen()"
              style="display:inline-block;background-color:#1bb24b;margin-top:20px;"
              type="success"
            >添加新商品详情内容</el-button>
          </div>
        </div>

        <div style="margin-top:20px;">
          <div style="display:inline-block;text-align:left;width:10%;">所属店铺</div>
          <el-select style="display:inline-block;width:70%;" v-model="form.belongShopId">
            <el-option v-for="item in shopList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>

        <!-- <div style="margin-top:20px;">
          <div style="display:inline-block;text-align:left;width:10%;">商品分类</div>
          <el-select
            @change="onCateChange"
            style="display:inline-block;width:25%;"
            v-model="form.belongCategoriesId"
          >
            <el-option
              v-for="item in categoriesList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <div style="margin-left:30px;display:inline-block;text-align:left;width:10%;">子分类</div>
          <el-select
            :disabled="fullscreenLoading"
            style="display:inline-block;width:25%;"
            v-model="form.belongSubCategoriesId"
          >
            <el-option
              v-for="item in subCategoriesList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>-->

        <div style="margin-top:20px;">
          <div style="display:inline-block;text-align:left;width:10%;">商品分类</div>
          <el-cascader
            style="width:70%"
            v-model="form.belongCategoriesList"
            :options="megaCategoriesList"
            :props="cateProps"
            clearable
          ></el-cascader>
        </div>

        <div style="margin-top:20px;">
          <div style="display:inline-block;text-align:left;width:10%;">商品单位</div>
          <el-select style="display:inline-block;width:70%;" v-model="form.unit">
            <el-option v-for="item in unitList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>

        <div style="margin-top:20px;">
          <div style="display:inline-block;text-align:left;width:10%;">特殊标签</div>
          <el-select style="display:inline-block;width:55%;" v-model="form.tag">
            <el-option
              v-for="item in specialList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-button
            type="danger"
            @click="onDeleteTag"
            style="display:inline-block;text-align:center;width:10%;margin-left:20px"
          >删除标签</el-button>
        </div>

        <div style="margin-top:20px;">
          <div style="display:inline-block;text-align:left;width:10%;">商品价格</div>
          <el-input
            type="number"
            :min="0"
            style="display:inline-block;width:70%;"
            v-model="form.price"
          ></el-input>
        </div>

        <div style="margin-top:20px;">
          <div style="display:inline-block;text-align:left;width:10%;">商品库存</div>
          <el-input
            type="number"
            :min="0"
            style="display:inline-block;width:70%;"
            v-model="form.storageNum"
          ></el-input>
        </div>

        <div style="margin-top:20px;">
          <div style="display:inline-block;text-align:left;width:10%;">商品销量</div>
          <el-input
            type="number"
            :min="0"
            style="display:inline-block;width:70%;"
            v-model="form.soldNum"
          ></el-input>
        </div>

        <div style="margin-top:20px;">
          <div style="display:inline-block;text-align:left;width:10%;">开启秒杀</div>
          <el-select style="display:inline-block;width:70%;" v-model="form.ifLimited">
            <el-option
              v-for="item in ifLimitedList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div style="margin-top:20px;">
          <div style="display:inline-block;text-align:left;width:10%;">运费满减</div>
          <el-select style="display:inline-block;width:70%;" v-model="form.is_offer">
            <el-option
                    v-for="item in is_offerList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div style="margin-top:20px;">
          <div style="display:inline-block;text-align:left;width:10%;">限售数量</div>
          <el-input
                  type="number"
                  :min="0"
                  style="display:inline-block;width:70%;"
                  v-model="form.limited_num"
          ></el-input>
        </div>
        <div style="margin-top:20px;">
          <div style="display:inline-block;text-align:left;width:10%;">配送日期</div>

          <el-date-picker
                  v-model="form.delivery_time"
                  value-format="yyyy-MM-dd"
                  style="display:inline-block;width:70%;"
                  type="date"
          ></el-date-picker>
        </div>

        <div style="text-align:right;margin-top:20px;">
          <el-button
            v-if="boolEdit"
            @click="onEditConfirm()"
            style="display:inline-block;margin-left:20px;background-color:#1bb24b;width:125px;"
            type="success"
          >确认</el-button>
          <el-button
            v-if="boolEdit ==false"
            @click="onAddNewConfirm()"
            style="display:inline-block;margin-left:20px;background-color:#1bb24b;width:125px;"
            type="success"
          >确认</el-button>
          <el-button
            @click="onDialogBoolAddNewClose()"
            style="color:#1bb24b;border-color:#1bb24b;width:125px;"
          >取消</el-button>
        </div>
      </el-dialog>

      <!-- for the product description  -->
      <el-dialog
        title="添加详细描述"
        :visible.sync="boolAddDescription"
        width="50%"
        style="text-align:left"
        :before-close="onDialogAddDescriptionClose"
      >
        <div>
          <div style="display:inline-block;text-align:left;width:10%;">类型</div>
          <el-select
            @change="onDescriptionTypeChange"
            style="display:inline-block;width:70%;"
            v-model="formDescription.type"
          >
            <el-option v-for="item in descriptionType" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>

        <div v-if="formDescription.type == '文字'" style="margin-top:20px;">
          <div style="display:inline-block;text-align:left;width:10%;vertical-align:top">内容</div>
          <el-input
            type="textarea"
            :rows="10"
            style="display:inline-block;width:70%;"
            v-model="formDescription.context"
          ></el-input>
        </div>

        <div v-if="formDescription.type == '图片'" style="margin-top:20px;">
          <div style="display:inline-block;text-align:left;width:10%;vertical-align:top">内容</div>
          <div style="display:inline-block;width:70%;">
            <el-upload
              accept=".jpg, .jpeg, .png"
              class="avatar-uploader"
              :show-file-list="false"
              action="https://freshgo.top/api/public/api/v1/uploadFileQiniu"
              :on-success="onDescriptionUpload"
              :on-remove="onDescriptionRemove"
            >
              <img v-if="formDescription.context" :src="formDescription.context" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </div>

        <div style="text-align:right;margin-top:20px;">
          <el-button
            @click="onAddDescriptionConfirm()"
            style="display:inline-block;margin-left:20px;background-color:#1bb24b;width:125px;"
            type="success"
          >确认</el-button>
          <el-button
            @click="onDialogAddDescriptionClose()"
            style="color:#1bb24b;border-color:#1bb24b;width:125px;"
          >取消</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="修改产品状态"
        :visible.sync="boolChangeShelf"
        width="50%"
        style="text-align:left"
        :before-close="onDialogBoolChangeShelfClose"
      >
        <div style="text-align:right;margin-top:20px;">
          <el-button
            @click="onStatusChangeConfirm()"
            style="display:inline-block;margin-left:20px;background-color:#1bb24b;width:125px;"
            type="success"
          >确认</el-button>
          <el-button
            @click="onDialogBoolChangeShelfClose()"
            style="color:#1bb24b;border-color:#1bb24b;width:125px;"
          >取消</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="批量修改产品状态"
        :visible.sync="boolMultipleStatus"
        width="50%"
        style="text-align:left"
        :before-close="onDialogBoolMultipleStatusClose"
      >
        <div style="margin-top:20px;">
          <div style="display:inline-block;text-align:left;width:10%;">商品状态</div>
          <el-select style="display:inline-block;width:70%;" v-model="selectedStatus">
            <el-option v-for="item in statusList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>

        <div style="text-align:right;margin-top:20px;">
          <el-button
            @click="onMultipleStatusChangeConfirm()"
            style="display:inline-block;margin-left:20px;background-color:#1bb24b;width:125px;"
            type="success"
          >确认</el-button>
          <el-button
            @click="onDialogBoolMultipleStatusClose()"
            style="color:#1bb24b;border-color:#1bb24b;width:125px;"
          >取消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: "productList",
  data() {
    return {
      fullscreenLoading: false,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,

      searchKeyword: "",
      searchPrice: "",
      searchUnit: "",
      searchStorage: "",

      currentData: {},
      currentPage: 1,
      tableDataList: [],
      tableDataTotal: 0,
      tableSelection: [],

      boolAddNew: false,
      boolEdit: false,
      boolAddDescription: false,
      boolEditDescription: false,
      boolChangeShelf: false,

      form: {
        belongShopId: "",
        title: "",
        price: "",
        imgUrls: [],
        description: [],
        tag: "",
        unit: "",
        storageNum: "",
        soldNum: "",
        detail: "",
        belongCategoriesList: [],
        ifLimited: false,
        is_offer:0,
        limited_num:"",
        delivery_time:"",
      },

      formDescription: {
        type: "",
        context: "",
      },

      descriptionType: ["文字", "图片"],
      editDescriptionIndex: 0,

      ifLimitedList: [
        { label: "是", value: true },
        { label: "否", value: false },
      ],

      is_offerList: [
        { label: "是", value: 0 },
        { label: "否", value: 1  },
      ],

      ifLimitedSearchList: [
        { label: "不限", value: "" },
        { label: "是秒杀", value: true },
        { label: "否", value: false },
      ],
      searchLimited: "",

      unitList: [
        "kg",
        "g",
        "份",
        "盒",
        "包",
        "把",
        "袋",
        "颗",
        "个",
        "件",
        "箱",
        "桶",
        "瓶",
        "听",
        "根",
        "捆",
        "篮",
        "只",
        "支",
        "头",
        "条",
      ],
      unitListTwo: [
        "不限",
        "kg",
        "g",
        "份",
        "盒",
        "包",
        "把",
        "袋",
        "颗",
        "个",
        "件",
        "箱",
        "桶",
        "瓶",
        "听",
        "根",
        "捆",
        "篮",
        "只",
        "支",
        "头",
        "条",
      ],
      shopList: [],
      searchShop: "",
      categoriesList: [],
      subCategoriesList: [],
      specialList: [],
      currentStatus: "",

      megaCategoriesList: [],
      cateProps: { multiple: true },
      cateTwoProps: { multiple: false },

      boolMultipleStatus: false,
      statusList: [
        { label: "不限状态", value: "" },
        { label: "在架", value: "在架" },
        { label: "下架", value: "下架" },
      ],
      selectedStatus: "",
      searchStatus: "",
      searchCate: "",


      orderList: [
        "库存从高到低",
        "库存从低到高",
        "销量从高到低",
        "销量从低到高",
      ],
      searchOrder: [],
    };
  },
  mounted() {},
  created() {
    this.onCheckloginRole();
    this.onFetchTableData();
    this.onFetchProductMegaCategoriesData();
    // this.onFetchProductCategoriesData();
    // this.onFetchProductSubCategoriesData();
    this.onFetchShopData();
    this.onFetchSpecialCategoriesData();
  },
  methods: {
    // check if  login
    onCheckloginRole() {
      // var temp = localStorage.getItem("auth");
      // if (temp == undefined || temp != "b60afdc1f3657130c165d32743603a59") {
      //   this.$router.push("/login");
      // }
       var temp = localStorage.getItem("auth");
      this.axios.post(this.$urlGlobal + "adminCheck", {
        auth: temp
      }).then((res) => {
        if (res.data.code == -1) {
          this.$router.push("/login");
          localStorage.removeItem("auth");
      window.location.reload();
        }
      });
    },

    // product selection
    onProductSelection(val) {
      console.log(val);
      this.tableSelection = val;
    },

    // search  table by name
    onSearchTableData() {
      // init the page and fetch data
      this.currentPage = 1;
      this.onFetchTableData();
    },
    // fetch table data also with condition
    onFetchTableData() {
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminFetchProduct", {
          keyword: this.searchKeyword,
          price: this.searchPrice,
          cate: this.searchCate,
          shop: this.searchShop,
          status: this.searchStatus,
          storageNum: this.searchStorage,
          ifLimited: this.searchLimited,
          is_offer:this.is_offer,
          limited_num:this.limited_num,
          delivery_time:this.delivery_time,
          unit: this.searchUnit,
          page: this.currentPage,
          order: this.searchOrder,
        })
        .then((res) => {
          this.tableDataList = res.data.data.data;
          this.tableDataTotal = res.data.data.total;
          this.fullscreenLoading = false;
        });
    },

    // mega categories
    onFetchProductMegaCategoriesData() {
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminFetchMegaCategories", {})
        .then((res) => {
          this.megaCategoriesList = res.data.data;
          this.fullscreenLoading = false;
        });
    },
    // fetch categories
    onFetchProductCategoriesData() {
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminFetchCategories", {})
        .then((res) => {
          this.categoriesList = res.data.data;
          this.fullscreenLoading = false;
        });
    },
    onCateChange() {
      this.form.belongSubCategoriesId = "";
      this.onFetchProductSubCategoriesData();
    },
    // fetch sub categories
    onFetchProductSubCategoriesData() {
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminFetchSubCategoriesById", {
          belongCategoriesId: this.form.belongCategoriesId,
        })
        .then((res) => {
          console.log(res.data);
          this.subCategoriesList = res.data.data;
          this.fullscreenLoading = false;
        });
    },
    // fetch special categories
    onFetchSpecialCategoriesData() {
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminFetchSpecialCategories", {})
        .then((res) => {
          this.specialList = res.data.data;
          this.fullscreenLoading = false;
        });
    },

    // fetch shop
    onFetchShopData() {
      this.fullscreenLoading = true;
      this.axios.post(this.$urlGlobal + "adminFetchShop", {}).then((res) => {
        this.shopList.push({ name: "不限", id: "" });
        this.shopList.push(...res.data.data);
      });
    },

    // add new product operation
    onDeleteTag() {
      this.form.tag = null;
    },
    onDialogBoolAddNewOpen() {
      this.boolAddNew = true;
    },
    onDialogBoolAddNewClose() {
      this.boolAddNew = false;
      // also close edit because they use same form
      this.boolEdit = false;
      this.form = {
        belongCategoriesList: [],
        belongShopId: "",
        belongCategoriesId: "",
        belongSubCategoriesId: "",
        title: "",
        price: "",
        imgUrls: [],
        description: [],
        tag: "",
        unit: "",
        detail: "",
        storageNum: "",
        soldNum: "",
        ifLimited: false,
        is_offer:0,
        limited_num:"",
        delivery_time:"",
      };
    },
    onAddNewConfirm() {
      if (
        this.form.belongShopId == "" ||
        this.form.belongCategoriesList.length == 0 ||
        this.form.title == "" ||
        this.form.price == "" ||
        this.form.imgUrls.length == 0 ||
        this.form.unit == "" ||
        this.form.storageNum.length == 0 ||
        this.form.storageNum == 0 ||
        this.form.soldNum.length == 0
      ) {
        console.log(this.form);
        this.$message({
          message: "尚有未填信息，或库存为0",
          type: "warning",
        });
        return;
      }

      var imgUrl = [];
      for (var i = 0; i < this.form.imgUrls.length; i++) {
        if (this.form.imgUrls[i].response != undefined) {
          imgUrl.push(this.form.imgUrls[i].response.data);
        } else {
          imgUrl.push(this.form.imgUrls[i].url);
        }
      }

      var belongCategoriesIdList = [];
      for (var i = 0; i < this.form.belongCategoriesList.length; i++) {
        if (
          !belongCategoriesIdList.includes(this.form.belongCategoriesList[i][0])
        ) {
          belongCategoriesIdList.push(this.form.belongCategoriesList[i][0]);
        }
      }

      this.fullscreenLoading = true;
      this.boolAddNew = false;
      this.axios
        .post(this.$urlGlobal + "adminAddNewProduct", {
          belongShopId: this.form.belongShopId,
          belongCategoriesList: this.form.belongCategoriesList,
          belongCategoriesIdList: belongCategoriesIdList.join(","),
          title: this.form.title,
          price: this.form.price,
          imgUrls: imgUrl,
          description: this.form.description,
          detail: this.form.detail,
          tag: this.form.tag,
          unit: this.form.unit,
          storageNum: this.form.storageNum,
          soldNum: this.form.soldNum,
          ifLimited: this.form.ifLimited,
          is_offer:this.form.is_offer,
          limited_num:this.form.limited_num,
          delivery_time:this.form.delivery_time,
        })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == 1) {
            this.$message({
              message: "操作失败",
              type: "warning",
            });
          } else {
            this.$message({
              message: "操作成功",
              type: "success",
            });
          }
          this.onDialogBoolAddNewClose();
          this.onFetchTableData();
        });
    },

    // product img upload
    onProductImgUpload(res, file, fileList) {
      this.form.imgUrls = fileList;
    },
    onProductImgRemove(file, fileList) {
      this.form.imgUrls = fileList;
    },

    // add description to product
    onDialogAddDescriptionOpen() {
      this.boolAddDescription = true;
    },
    // edit description open
    onDialogEditDescriptionOpen(scope) {
      this.boolAddDescription = true;
      this.boolEditDescription = true;
      this.formDescription = {
        type: scope.row.type,
        context: scope.row.context,
      };
    },
    onAddDescriptionConfirm() {
      if (
        this.formDescription.type == "" ||
        this.formDescription.context == ""
      ) {
        this.$message({
          message: "尚有未填信息",
          type: "warning",
        });
        return;
      }

      if (this.boolEditDescription) {
        // this.form.description[this.editDescriptionIndex] = this.formDescription;
        var temp = [];
        for (var i = 0; i < this.form.description.length; i++) {
          if (i == this.editDescriptionIndex) {
            temp.push(this.formDescription);
          } else {
            temp.push(this.form.description[i]);
          }
        }
        this.form.description = temp;
      } else {
        this.form.description.push(this.formDescription);
      }
      this.onDialogAddDescriptionClose();
    },
    onDialogAddDescriptionClose() {
      this.boolAddDescription = false;
      this.boolEditDescription = false;
      this.formDescription = {
        type: "",
        context: "",
      };
    },
    onDescriptionTypeChange() {
      this.formDescription.context = "";
    },
    // upload description image
    onDescriptionUpload(file) {
      this.formDescription.context = file.data;
    },
    onDescriptionRemove(file, fileList) {
      this.formDescription.context = "";
    },
    // description table operation
    onDialogDescriptionWithData(scope, e) {
      //this.currentData = scope.row;
      this.editDescriptionIndex = scope.$index;
      switch (e) {
        case "edit":
          this.onDialogEditDescriptionOpen(scope);
          break;
        case "delete":
          var temp = [];
          for (var i = 0; i < this.form.description.length; i++) {
            if (i != scope.$index) {
              temp.push(this.form.description[i]);
            }
          }
          this.form.description = temp;
          break;
      }
    },

    // edit operation
    onDialogBoolEditOpen() {
      this.boolAddNew = true;
      this.boolEdit = true;
      var tempImgUrl = [];
      for (var i = 0; i < this.currentData.imgUrls.length; i++) {
        tempImgUrl.push({ name: i, url: this.currentData.imgUrls[i] });
      }
      console.log(this.currentData);
      this.form = {
        belongCategoriesList: this.currentData.belongCategoriesList,
        belongShopId: parseInt(this.currentData.shopId),
        belongCategoriesId: parseInt(this.currentData.categoriesId),
        belongSubCategoriesId: parseInt(this.currentData.subCategoriesId),
        title: this.currentData.title,
        detail: this.currentData.detail,
        price: this.currentData.price,
        imgUrls: tempImgUrl,
        description: this.currentData.description,
        tag: this.currentData.tag,
        unit: this.currentData.unit,
        storageNum: this.currentData.storageNum,
        soldNum: this.currentData.soldNum,
        ifLimited: this.currentData.ifLimited,
        is_offer:this.currentData.is_offer,
        limited_num:this.currentData.limited_num,
        delivery_time:this.currentData.delivery_time,
      };

      // this.onFetchProductSubCategoriesData();
    },
    onEditConfirm() {
      console.log(this.form.storageNum);
      if (
        this.form.belongShopId == "" ||
        this.form.belongCategoriesList.length == 0 ||
        this.form.title == "" ||
        this.form.price == "" ||
        this.form.imgUrls.length == 0 ||
        this.form.unit == "" ||
        this.form.storageNum.length == 0 ||
        this.form.soldNum.length == 0
      ) {
        this.$message({
          message: "尚有未填信息",
          type: "warning",
        });
        return;
      }

      var imgUrl = [];
      for (var i = 0; i < this.form.imgUrls.length; i++) {
        if (this.form.imgUrls[i].response != undefined) {
          imgUrl.push(this.form.imgUrls[i].response.data);
        } else {
          imgUrl.push(this.form.imgUrls[i].url);
        }
      }

      var belongCategoriesIdList = [];
      for (var i = 0; i < this.form.belongCategoriesList.length; i++) {
        if (
          !belongCategoriesIdList.includes(this.form.belongCategoriesList[i][0])
        ) {
          belongCategoriesIdList.push(this.form.belongCategoriesList[i][0]);
        }
      }

      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminEditProduct", {
          id: this.currentData.productId,
          belongShopId: this.form.belongShopId,
          belongCategoriesList: this.form.belongCategoriesList,
          belongCategoriesIdList: belongCategoriesIdList.join(","),
          title: this.form.title,
          price: this.form.price,
          imgUrls: imgUrl,
          description: this.form.description,
          detail: this.form.detail,
          tag: this.form.tag,
          unit: this.form.unit,
          storageNum: this.form.storageNum,
          soldNum: this.form.soldNum,
          ifLimited: this.form.ifLimited,
          is_offer:this.form.is_offer,
          limited_num:this.form.limited_num,
          delivery_time:this.form.delivery_time,

        })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == 1) {
            this.$message({
              message: "操作失败",
              type: "warning",
            });
          } else {
            this.$message({
              message: "操作成功",
              type: "success",
            });
          }
          this.onDialogBoolAddNewClose();
          this.onFetchTableData();
        });
    },

    // delete  operation
    onDialogBoolChanegShelfOpen() {
      this.boolChangeShelf = true;
    },
    onDialogBoolChangeShelfClose() {
      this.boolChangeShelf = false;
    },
    onStatusChangeConfirm() {
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminModifyProductStatus", {
          id: this.currentData.productId,
          status: this.currentStatus,
        })
        .then((res) => {
          this.fullscreenLoading = false;
          this.$message({
            message: "修改成功",
            type: "success",
          });
          this.onDialogBoolChangeShelfClose();
          this.onFetchTableData();
        });
    },

    // multiple status change
    onDialogBoolMultipleStatusOpen() {
      this.boolMultipleStatus = true;
    },
    onDialogBoolMultipleStatusClose() {
      this.boolMultipleStatus = false;
      this.selectedStatus = "";
    },
    onMultipleStatusChangeConfirm() {
      this.fullscreenLoading = true;
      var temp = [];
      for (var i = 0; i < this.tableSelection.length; i++) {
        temp.push(this.tableSelection[i].productId);
      }
      this.axios
        .post(this.$urlGlobal + "adminModifyMultipleProductStatus", {
          ids: temp,
          status: this.selectedStatus,
        })
        .then((res) => {
          this.fullscreenLoading = false;
          this.$message({
            message: "修改成功",
            type: "success",
          });
          this.onDialogBoolMultipleStatusClose();
          this.onFetchTableData();
        });
    },

    // table operation
    onDialogWithData(scope, e) {
      this.currentData = scope.row;
      switch (e) {
        case "edit":
          this.onDialogBoolEditOpen();
          break;
        case "onShelf":
          this.boolChangeShelf = true;
          this.currentStatus = "在架";
          this.onDialogBoolChanegShelfOpen();
          break;
        case "offShelf":
          this.currentStatus = "下架";
          this.boolChangeShelf = true;
          this.onDialogBoolChanegShelfOpen();
          break;
        case "delete":
          this.currentStatus = "已删除";
          this.onDialogBoolChanegShelfOpen();
          break;
      }
    },
  },
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>

